function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import getInboxAuthors from "./getInboxAuthors";
import getInboxLabel from "./getInboxLabel";
import getInboxBody from "./getInboxBody";
import getUrlFromProps from "./getUrlFromProps";
export const getInboxModule = props => {
  const inboxType = props.inboxType,
        title = props.title,
        messages = props.messages,
        messagesCount = props.messagesCount,
        updatedAt = props.updatedAt,
        createdAt = props.createdAt,
        uniqueId = props.uniqueId,
        urlPattern = props.urlPattern;
  const datetime = updatedAt || createdAt;

  if (!messages) {
    return props;
  } // url


  const url = getUrlFromProps(props); // authors

  const _getInboxAuthors = getInboxAuthors(props),
        authors = _getInboxAuthors.authors,
        authorNames = _getInboxAuthors.authorNames; // messages


  let count = parseInt(messagesCount) || messages && parseInt(messages.length);

  if (count < 2) {
    count = undefined;
  } // first message


  const m1 = messages[0];
  const author = m1.author,
        subject = m1.subject,
        message = m1.message;

  const _getInboxBody = getInboxBody({
    message
  }),
        text = _getInboxBody.text,
        markdown = _getInboxBody.markdown; // label + color


  const _getInboxLabel = getInboxLabel(props),
        label = _getInboxLabel.label,
        labelColor = _getInboxLabel.labelColor; // from


  return _extends({}, props, {
    url: url,
    datetime: datetime,
    author: author,
    authors: authors,
    authorNames: authorNames,
    messagesCount: count,
    subject: subject || title,
    message: text,
    label: label,
    labelColor: labelColor
  });
};
export default getInboxModule;